(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-trustpilot-product-schema"] && !Shopify.designMode) return;
  try {
    
  const productReviewSchemaContainer = document.getElementById("productReviewSchemaContainer");
  let productId = productReviewSchemaContainer.dataset.productId || "";
  let businessUnitId = productReviewSchemaContainer.dataset.businessUnitId || "";
  let trustpilotApiKeySuffix = productReviewSchemaContainer.dataset.reviewIdentifier || "";
  let trustpilotApiKey = "tpk-" + trustpilotApiKeySuffix;

  if (productId !== "" && trustpilotApiKey !== "tpk-") {
    getTrustpilotProductReviews(businessUnitId, trustpilotApiKey, productId);
    getTrustpilotAggregateReviewScore(businessUnitId, trustpilotApiKey, productId);
  }

  async function getTrustpilotProductReviews(businessUnitId, apikey, productId) {
    await fetch(`https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}/reviews?sku=${productId}&perPage=5&page=1&apikey=${apikey}`)
    .then(data => {
        if (data.ok) return data.json();
        throw new Error(data);
    })
    .then(data => {
        if (data.productReviews.length > 0) {
            data.productReviews.forEach(element => {
                let reviewElement = document.createElement("div");
                reviewElement.setAttribute("itemprop", "review");
                reviewElement.setAttribute("itemscope", "");
                reviewElement.setAttribute("itemtype", "https://schema.org/Review");

                let reviewNameElement = document.createElement("div");
                reviewNameElement.setAttribute("itemprop", "author");
                reviewNameElement.setAttribute("itemscope", "");
                reviewNameElement.setAttribute("itemtype", "https://schema.org/Person");

                let reviewNameValueElement = document.createElement("p");
                reviewNameValueElement.setAttribute("itemprop", "name");
                reviewNameValueElement.textContent = element.consumer.displayName;

                reviewNameElement.appendChild(reviewNameValueElement);

                let reviewContentElement = document.createElement("p");
                reviewContentElement.setAttribute("itemprop", "reviewBody");
                reviewContentElement.textContent = element.content;

                let reviewRatingElement = document.createElement("div");
                reviewRatingElement.setAttribute("itemprop", "reviewRating");
                reviewRatingElement.setAttribute("itemscope", "");
                reviewRatingElement.setAttribute("itemtype", "https://schema.org/Rating");                

                let reviewRatingElementScore = document.createElement("p");
                reviewRatingElementScore.setAttribute("itemprop", "ratingValue");
                reviewRatingElementScore.textContent = element.stars;

                reviewRatingElement.appendChild(reviewRatingElementScore);

                reviewElement.appendChild(reviewNameElement);
                reviewElement.appendChild(reviewContentElement);
                reviewElement.appendChild(reviewRatingElement);

                productReviewSchemaContainer.innerText = "";
                productReviewSchemaContainer.innerHTML = "";
                productReviewSchemaContainer.appendChild(reviewElement);
            });
        }
    })
    .catch(error => { });
  }

  async function getTrustpilotAggregateReviewScore(businessUnitId, apikey, productId) {
    await fetch(`https://api.trustpilot.com/v1/product-reviews/business-units/${businessUnitId}?sku=${productId}&apikey=${apikey}`)
    .then(data => {
        if (data.ok) return data.json();
        throw new Error(data);
    })
    .then(data => {
        if (data?.numberOfReviews?.total !== null && !isNaN(data?.numberOfReviews.total) && Number(data?.numberOfReviews?.total) > 0) {
            let productReviewRatingSchemaContainer = document.getElementById("productReviewRatingSchemaContainer");

            let reviewAggregateRatingElement = document.createElement("div");
            reviewAggregateRatingElement.setAttribute("itemscope", "");
            reviewAggregateRatingElement.setAttribute("itemtype", "https://schema.org/AggregateRating");
            reviewAggregateRatingElement.setAttribute("itemprop", "aggregateRating");

            let reviewCountElement = document.createElement("p");
            reviewCountElement.setAttribute("itemprop", "reviewCount");
            reviewCountElement.textContent = data.numberOfReviews.total;

            let reviewAverageScoreElement = document.createElement("p");
            reviewAverageScoreElement.setAttribute("itemprop", "ratingValue");
            reviewAverageScoreElement.textContent = data.starsAverage;


            reviewAggregateRatingElement.appendChild(reviewCountElement);
            reviewAggregateRatingElement.appendChild(reviewAverageScoreElement);

            productReviewRatingSchemaContainer.textContent = "";
            productReviewRatingSchemaContainer.innerHTML = "";
            productReviewRatingSchemaContainer.appendChild(reviewAggregateRatingElement);
        }
    })
    .catch(error => { });
  }

  } catch(e) { console.error(e); }
})();
})();
